import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminBulkArticles from "@/pages/admin/AdminBulkArticles";

export const Route = createFileRoute("/admin/bulk-articles")({
  component: () => (
    <ProtectedRoute>
      <AdminBulkArticles />
    </ProtectedRoute>
  ),
});
